import FeeInvoiceModel from '../models/fee-invoice.model';

let storeContent = utils.generateStore({
	FeeInvoiceModel,
	school_invoices: [],
	application_charges: null,
	selected_invoice: null,
	invoice_details: null,
	invoice_breakdown: null,
	lender_details: null,
	invoice_system_ref: null,
	payment_breakdown: [],
	lenders: [],
	bank_payment_schedule: [],
	simulated_loan_details: null,
	selected_lender: null,
	application_system_ref: null,
	schedule_details: [],
	schedule_summary_details: null,
	loan_config_details: null,
	loan_application_details: null,
	get_finance_data: null,
	selected_lender_id: '0',
	showInvoice: false,
	showPaymentBreakdown: false,
	showMakePayment: false,
	showRequestFinance: false,
	acc_balance: 0,
	acc_balance_currency: 0,
	current_finance_page: 1,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async navigateNextStepInvoice(ctx, payload) {
			try {
				ctx.commit('loading', true);
				if (ctx.getters.current_finance_page == 1) {
					if (await payload.request_finance.isValid()) {
						await ctx.dispatch('createInvoiceFinance', payload);
					}
				} else if (ctx.getters.current_finance_page == 2) {
					if (ctx.getters.selected_lender_id) {
						await ctx.dispatch('fetchLenderDetails');
						ctx.commit('current_finance_page', 3);
					} else {
						$notify(
							'warning',
							'Select Lender',
							`Select a lender to continue`,
							3,
						);
					}
				} else if (ctx.getters.current_finance_page == 3) {
					await ctx.dispatch('fetchLoanPaymentDetails');
					ctx.commit('current_finance_page', 4);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchLenderDetails(ctx, payload) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'product_details',
						data: {
							loan_product_system_ref:
								ctx.getters.selected_lender
									.loan_product_system_ref,
						},
					},
					'/client',
				);

				ctx.commit('lender_details', res.result);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async createInvoiceFinance(ctx, payload) {
			try {
				let data = payload.request_finance.formData_;
				ctx.commit(
					'invoice_system_ref',
					ctx.getters.invoice_details.nexus_invoice_details.invoice
						.invoice_system_ref,
				);

				if (
					data.amount >
					ctx.getters.invoice_details.nexus_invoice_details.invoice
						.invoice_amount
				) {
					$notify(
						'warning',
						'Amount Exceeds',
						`Amount provided exceeds the invoice amount`,
						6,
					);
					return false;
				}
				if (
					ctx.getters.get_finance_data &&
					data.amount >
						ctx.getters.get_finance_data.amt_available_for_finance
				) {
					$notify(
						'warning',
						'Amount Exceeds',
						`Amount provided exceeds the available finance amount`,
						10,
					);
					return false;
				}

				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'create',
						data: {
							invoice_system_ref: ctx.getters.invoice_system_ref,
							amount: data.amount,
							term: data.period,
							preffered_repayment_date:
								data.preferred_payment_date,
						},
					},
					'/client',
				);

				ctx.commit(
					'application_system_ref',
					res.result.application_system_ref,
				);
				await ctx.dispatch(
					'fetchLenders',
					res.result.application_system_ref,
				);
				ctx.commit('current_finance_page', 2);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async acceptFinancing(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (
					(await payload.accept_bank.isValid()) &&
					(await payload.loan_payment_options.isValid())
				) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'invoice_financing',
							action: 'accept_offer',
							data: {
								// invoice_system_ref: ctx.getters.invoice_system_ref,
								application_system_ref:
									ctx.getters.application_system_ref,
								loan_product_system_ref:
									ctx.getters.selected_lender
										.loan_product_system_ref,
								loan_product_tnc_ref:
									ctx.getters.selected_lender
										.loan_product_tnc_ref,
								system_tnc_ref: 'test-1',
								repayment_options:
									payload.loan_payment_options.formData_
										.payment_option.length > 0
										? payload.loan_payment_options.formData_.payment_option.map(
												(el) => {
													return el.ClientTopupOption_id;
												},
											)
										: [],
							},
						},
						'/client',
					);

					await ctx.dispatch('fetchSchoolsInvoices');
					ctx.commit('showRequestFinance', false);
					ctx.commit('showMakePayment', false);
					ctx.commit('showInvoice', false);
					ctx.commit('current_finance_page', 1);
					$notify(
						'success',
						'Financing Requested',
						`Financing successfully requested for invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref}</b>. Financing is currently being processed.`,
						10,
					);
					// await ctx.dispatch('fetchPaymentBreakdown')
					// ctx.commit('showPaymentBreakdown', true)
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async rejectFinancing(ctx, payload) {
			try {
				ctx.commit('loading', true);

				// if (await payload.accept_bank.isValid()) {
				//    let res = await api.fetchEndpointSecure({
				//       resource: "invoice_financing",
				//       action: "accept",
				//       data: {
				//          invoice_system_ref: ctx.getters.invoice_system_ref,
				//          application_system_ref: ctx.getters.application_system_ref,
				//          // loan_product_system_ref: ctx.getters.selected_lender.loan_product_details.product_system_ref,
				//          loan_product_system_ref: ctx.getters.selected_lender_id,
				//          loan_product_tnc: true,
				//          repayment_options: [1,3],
				//       }
				//    }, '/client')

				//    await ctx.dispatch('fetchSchoolsInvoices')
				//    // await ctx.dispatch('fetchPaymentBreakdown')
				//    // ctx.commit('showPaymentBreakdown', true)
				// }

				ctx.commit('showRequestFinance', false);
				ctx.commit('showMakePayment', false);
				ctx.commit('showInvoice', false);
				ctx.commit('current_finance_page', 1);
				$notify(
					'warning',
					'Financing Rejected',
					`Financing for invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref} rejected.</b>`,
					10,
				);
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchPaymentDetails(ctx, account_number) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'details',
						data: { account_number },
					},
					'/client',
				);

				if (res.result) {
					ctx.commit(
						'acc_balance_currency',
						res.result.currency_code,
					);
					ctx.commit('acc_balance', res.result.available_balance);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLoanConfigDetails(ctx) {
			try {
				// let res = await api.fetchEndpointSecure({
				//    resource: "invoice_financing",
				//    action: "config",
				//    data: {
				//       config_type: "school",
				//    }
				// }, '/client')

				// if(res.result){
				let model = FeeInvoiceModel;
				model.forms.request_finance.forms[1].min = 1;
				model.forms.request_finance.forms[1].max =
					ctx.getters.get_finance_data.max_loan_tenor;
				model.forms.request_finance.data.period = 1;
				ctx.commit('FeeInvoiceModel', model);
				// }
			} catch (err) {
				throw err;
			}
		},
		async fetchLoanPaymentDetails(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'generate_offer',
						data: {
							// invoice_system_ref: ctx.getters.invoice_system_ref,
							application_system_ref:
								ctx.getters.application_system_ref,
							loan_product_system_ref:
								ctx.getters.selected_lender
									.loan_product_system_ref,
						},
					},
					'/client',
				);

				ctx.commit(
					'schedule_details',
					res.result.loan_offer_details.loan_schedule,
				);
				ctx.commit(
					'application_charges',
					res.result.loan_offer_details.charges,
				);
				ctx.commit(
					'schedule_summary_details',
					res.result.loan_offer_details.loan_summary,
				);
				ctx.commit(
					'loan_application_details',
					res.result.loan_offer_details.application_details,
				);
				await ctx.dispatch(
					'fetchPaymentOptions',
					res.result.loan_offer_details.invoice_details,
				);
			} catch (err) {
				throw err;
			}
		},
		async openRequestInvoiceFinance(ctx, { accept_terms }) {
			try {
				if (await accept_terms.isValid()) {
					let model = FeeInvoiceModel;

					model.forms.request_finance.data.amount = Math.round(
						ctx.getters.get_finance_data.amt_available_for_finance,
					);
					ctx.commit('FeeInvoiceModel', model);
					Event.$emit('loader:show', true);
					await ctx.dispatch('fetchLoanConfigDetails');
					ctx.commit('showRequestFinance', true);
					Event.$emit('loader:show', false);
				}
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async paySchoolInvoice(ctx, { accept_terms }) {
			try {
				ctx.commit(
					'invoice_system_ref',
					ctx.getters.invoice_details.nexus_invoice_details.invoice
						.invoice_system_ref,
				);
				if (await accept_terms.isValid()) {
					Event.$emit('loader:show', true);

					let res = await api.fetchEndpointSecure(
						{
							resource: 'school_invoice',
							action: 'payment',
							data: {
								invoice_system_ref:
									ctx.getters.invoice_system_ref,
							},
						},
						'/client',
					);

					if (res.result) {
						await ctx.dispatch('fetchSchoolsInvoices');
						ctx.commit('showRequestFinance', false);
						ctx.commit('showMakePayment', false);
						ctx.commit('showInvoice', false);
						// ctx.commit('showInvoice', false)
						$notify(
							'success',
							'Invoice Paid',
							`Invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref}</b> successfully paid.`,
							10,
						);
					}
					Event.$emit('loader:show', false);
				}
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async payInvoice(ctx, invoice_system_ref) {
			try {
				ctx.commit(
					'invoice_system_ref',
					ctx.getters.invoice_details.nexus_invoice_details.invoice
						.invoice_system_ref,
				);

				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice',
						action: 'payment_request',
						data: {
							invoice_system_ref: ctx.getters.invoice_system_ref,
						},
					},
					'/client',
				);

				if (res.result) {
					// await ctx.dispatch('fetchSchoolsInvoices')
					ctx.commit('showRequestFinance', false);
					ctx.commit('showMakePayment', false);
					ctx.commit('showInvoice', false);
					//ctx.commit('showInvoice', false)
					$notify(
						'success',
						'Invoice Paid',
						`Invoice: <b class="tx-uppercase">${ctx.getters.invoice_system_ref}</b> successfully paid.`,
						10,
					);
				}
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLenders(ctx, application_ref) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'loan_products',
						data: {
							application_system_ref: application_ref,
						},
					},
					'/client',
				);

				ctx.commit('current_finance_page', 1);

				if (res.result.loan_products) {
					ctx.commit('lenders', res.result.loan_products);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchSchoolsInvoices(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'school_invoice',
						action: 'list',
						data: {},
					},
					'/client',
				);

				if (res.result.parent_invoices) {
					ctx.commit('school_invoices', res.result.parent_invoices);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchPaymentBreakdown(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				// let res = await api.fetchEndpointSecure(
				//    {
				//       resource: 'claim',
				//       action: 'details',
				//       data: {
				//          claim_id: payload.claim.claim_id,
				//       },
				//    },
				//    '/client'
				// );

				// ctx.commit('payment_breakdown', [
				//    {
				//       currency: 'KES',
				//       status: 'paid',
				//       academic_year: '2021',
				//       release_date: '2021-07-21T23:13:41.741Z',
				//       payment_date: '2021-07-21T23:13:41.741Z',
				//       payment_amount: 52000,
				//       released_amount: 52000,
				//       name: 'Term 1',
				//       from: '2021-02-01T18:59:30.712Z',
				//       to: '2021-04-28T18:59:30.712Z',
				//       mandatory: [
				//          { name: 'Tuition Fee', cost: 52000,},
				//          { name: 'Library Fee', cost: 500,},
				//          { name: 'School Bus', cost: 2500,},
				//          { name: 'Sports', cost: 8500,},
				//       ],
				//       optional: [
				//          { name: 'Swimming', cost: 3000, min: 2000, max: 5000},
				//          { name: 'Music', cost: 4000, min: 4000, max: 7000},
				//          { name: 'School Trip', cost: 15000, min: 15000, max: 15000},
				//       ]
				//    },
				//    {
				//       currency: 'KES',
				//       status: 'Waiting',
				//       academic_year: '2021',
				//       payment_date: '2021-07-21T23:13:41.741Z',
				//       released_amount: 0,
				//       payment_amount: 48000,
				//       name: 'Term 2',
				//       from: '2021-05-09T18:59:30.712Z',
				//       to: '2021-08-14T18:59:30.712Z',
				//       mandatory: [
				//          { name: 'Tuition', cost: 47000,},
				//          { name: 'Library', cost: 500,},
				//          { name: 'School Bus', cost: 2500,},
				//          { name: 'Sports', cost: 6500,},
				//       ],
				//       optional: [
				//          { name: 'Swimming', cost: 3000, min: 2000, max: 5000},
				//          { name: 'Music', cost: 4000, min: 4000, max: 7000},
				//          { name: 'School Trip', cost: 15000, min: 15000, max: 15000},
				//       ]
				//    },
				//    {
				//       currency: 'KES',
				//       status: 'Waiting',
				//       academic_year: '2021',
				//       payment_date: '2021-07-21T23:13:41.741Z',
				//       released_amount: 0,
				//       payment_amount: 23000,
				//       name: 'Term 3',
				//       from: '2021-09-12T18:59:30.712Z',
				//       to: '2021-11-21T18:59:30.712Z',
				//       mandatory: [
				//          { name: 'Tuition', cost: 32000,},
				//          { name: 'Library', cost: 500,},
				//          { name: 'School Bus', cost: 2500,},
				//          { name: 'Sports', cost: 8500,},
				//       ],
				//       optional: [
				//          { name: 'Swimming', cost: 3000, min: 2000, max: 5000},
				//          { name: 'Music', cost: 4000, min: 4000, max: 7000},
				//          { name: 'School Trip', cost: 15000, min: 15000, max: 15000},
				//       ]
				//    },
				// ]);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async clickAction(ctx, event_name) {
			try {
				switch (event_name) {
					case 'payment_breakdown':
						await ctx.dispatch('fetchPaymentBreakdown');
						ctx.commit('showPaymentBreakdown', true);
						break;
					case 'get_financing':
						break;
					case 'make_payment':
						// await ctx.dispatch('fetchPaymentDetails')
						ctx.commit('showMakePayment', true);
						break;

					default:
						break;
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchPaymentOptions(ctx, invoice) {
			try {
				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'topup_options',
						data: {
							account_number: invoice.to_entity.account_number,
							amount: invoice.invoice_amount,
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: FeeInvoiceModel.forms.loan_payment_options,
					model: 'payment_option',
					label: 'channel_name',
					// $labelSupport: 'currency_code',
					// $label: 'available_balance',
					data: res.result.topup_options.account_topup_options,
				});

				if (form) {
					let Model = ctx.getters.FeeInvoiceModel;
					Model.forms.loan_payment_options = form;
					ctx.commit('FeeInvoiceModel', Model);
				}
			} catch (err) {
				throw err;
			}
		},
		async showPaymentBreakdown(ctx) {
			try {
				await ctx.dispatch('fetchPaymentBreakdown');
				ctx.commit('showPaymentBreakdown', true);
			} catch (err) {
				throw err;
			}
		},
		async showMakePayment(ctx) {
			try {
				if (ctx.getters.invoice_details.nexus_invoice_details) {
					await ctx.dispatch(
						'fetchPaymentDetails',
						ctx.getters.invoice_details.nexus_invoice_details
							.invoice.to_entity.account_number,
					);
				}
				ctx.commit('showMakePayment', true);
			} catch (err) {
				throw err;
			}
		},
		async fetchInvoiceDetails(ctx, invoice) {
			try {
				ctx.commit('selected_invoice', invoice);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'school_invoice',
						action: 'details',
						data: {
							parent_fee_invoice_system_ref:
								invoice.parent_fee_invoice_system_ref,
						},
					},
					'/client',
				);

				if (res.result.invoice_summary) {
					ctx.commit(
						'invoice_breakdown',
						res.result.invoice_breakdown.invoice_breakdown,
					);
					ctx.commit('invoice_details', res.result.invoice_summary);
					ctx.commit(
						'payment_breakdown',
						res.result.breakdown.fee_breakdown,
					);
					if (
						res.result.invoice_breakdown &&
						res.result.invoice_breakdown.invoice_breakdown &&
						res.result.invoice_breakdown.invoice_breakdown
							.invoice &&
						res.result.invoice_breakdown.invoice_breakdown.invoice
							.finance_option
					) {
						ctx.commit(
							'get_finance_data',
							res.result.invoice_breakdown.invoice_breakdown
								.invoice.finance_option,
						);
					}
				}
			} catch (err) {
				throw err;
			}
		},
		async viewSchoolInvoice(ctx, invoice) {
			try {
				Event.$emit('loader:show', true);
				// if(invoice.invoice_status === 'pending:payment'){
				await ctx.dispatch('fetchInvoiceDetails', invoice);
				// }else{
				//    $notify('warning', 'Select Lender', `Select a lender to continue`, 3);
				// }
				ctx.commit('showInvoice', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				Event.$emit('loader:show', true);
				await ctx.dispatch('fetchSchoolsInvoices');
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
	},
};
